module.exports = __webpack_public_path__ + "img/philou_skear.895ec12b.png";